import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e4c60d10"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidebar-header" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "lottie lottie-logo",
    id: "coderhouse-logo"
  })
], -1))
const _hoisted_2 = { class: "p-d-flex p-flex-column links-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-box__border--active" }, null, -1))
const _hoisted_4 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "label-icon p-ml-3 p2 medium" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-box__border--active" }, null, -1))
const _hoisted_8 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "label-icon p-ml-3 p2 medium" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-box__border--active" }, null, -1))
const _hoisted_12 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_13 = ["id"]
const _hoisted_14 = { class: "label-icon p-ml-3 p2 medium" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-box__border--active" }, null, -1))
const _hoisted_16 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_17 = ["id"]
const _hoisted_18 = { class: "label-icon p-ml-3 p2 medium" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-box__border--active" }, null, -1))
const _hoisted_20 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_21 = ["id"]
const _hoisted_22 = { class: "label-icon p-ml-3 p2 medium" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-box__border--active" }, null, -1))
const _hoisted_24 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_25 = ["id"]
const _hoisted_26 = { class: "label-icon p-ml-3 p2 medium" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-box__border--active" }, null, -1))
const _hoisted_28 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_29 = ["id"]
const _hoisted_30 = { class: "label-icon p-ml-3 p2 medium" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-box__border--active" }, null, -1))
const _hoisted_32 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_33 = ["id"]
const _hoisted_34 = { class: "label-icon p-ml-3 p2 medium" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-box__border--active" }, null, -1))
const _hoisted_36 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_37 = ["id"]
const _hoisted_38 = { class: "label-icon p-ml-3 p2 medium" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-box__border--active" }, null, -1))
const _hoisted_40 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_41 = ["id"]
const _hoisted_42 = { class: "label-icon p-ml-3 p2 medium" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-box__border--active" }, null, -1))
const _hoisted_44 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_45 = ["id"]
const _hoisted_46 = { class: "label-icon p-ml-3 p2 medium" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-box__border--active" }, null, -1))
const _hoisted_48 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_49 = ["id"]
const _hoisted_50 = { class: "label-icon p-ml-3 p2 medium" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-box__border--active" }, null, -1))
const _hoisted_52 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_53 = ["id"]
const _hoisted_54 = { class: "label-icon p-ml-3 p2 medium" }
const _hoisted_55 = { class: "p-mt-6 icon-box p-d-flex p-flex-column p-mb-5 bottom-content" }
const _hoisted_56 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_57 = { class: "label-icon p-ml-2 p3 text-light-gray" }
const _hoisted_58 = { class: "p-d-flex p-flex-row p-ai-center p-mt-3" }
const _hoisted_59 = { class: "label-icon p-ml-2 p3 text-light-gray" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_close = _resolveComponent("close")!
  const _component_icon = _resolveComponent("icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_help = _resolveComponent("help")!
  const _component_log_out = _resolveComponent("log-out")!

  return (_openBlock(), _createBlock(_Transition, {
    class: _normalizeClass(["p-d-flex p-flex-column sidebar p-ai-center", `${_ctx.isOpenMenu ? 'sidebar-open' : ''}`]),
    onMouseenter: _ctx.hoverEnter,
    onMouseleave: _ctx.removeHover
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "close-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCloseMenu && _ctx.handleCloseMenu(...args)))
        }, [
          _createVNode(_component_icon, { size: 16 }, {
            default: _withCtx(() => [
              _createVNode(_component_close)
            ]),
            _: 1
          })
        ]),
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: '/dashboard',
            class: _normalizeClass(["p-d-flex", `icon-box${_ctx.selectedTab === _ctx.NewPlatform.DASHBOARD ? '-active' : ''}`]),
            id: "sb-dashboard-wrapper"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: "lottie-icon",
                  id: `dashboard${_ctx.suffix}`
                }, null, 8, _hoisted_5),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.copies.Navigation.dashboard), 1)
              ])
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            to: '/classes',
            class: _normalizeClass(["p-d-flex", `icon-box${_ctx.selectedTab === _ctx.NewPlatform.CLASSES ? '-active' : ''}`]),
            id: "sb-classes-wrapper"
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: "lottie-icon",
                  id: `classes${_ctx.suffix}`
                }, null, 8, _hoisted_9),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.copies.Navigation.classes), 1)
              ])
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            to: '/challenges',
            class: _normalizeClass(["p-d-flex", `icon-box${_ctx.selectedTab === _ctx.NewPlatform.CHALLENGES ? '-active' : ''}`]),
            id: "sb-challenges-wrapper"
          }, {
            default: _withCtx(() => [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", {
                  class: "lottie-icon",
                  id: `challenges${_ctx.suffix}`
                }, null, 8, _hoisted_13),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.copies.Navigation.challenges), 1)
              ])
            ]),
            _: 1
          }, 8, ["class"]),
          (_ctx.role === 2)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_router_link, {
                  to: "/chat",
                  class: _normalizeClass(["p-d-flex", `icon-box${_ctx.selectedTab === _ctx.NewPlatform.CHAT ? '-active' : ''}`]),
                  id: "sb-chat-wrapper"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", {
                        class: "lottie-icon",
                        id: `chat${_ctx.suffix}`
                      }, null, 8, _hoisted_17),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.copies.Navigation.chat), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_router_link, {
                  to: "/commission",
                  class: _normalizeClass(["p-d-flex", `icon-box${_ctx.selectedTab === _ctx.NewPlatform.COMMISSION ? '-active' : ''}`]),
                  id: "sb-commission-wrapper"
                }, {
                  default: _withCtx(() => [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", {
                        class: "lottie-icon",
                        id: `commission${_ctx.suffix}`
                      }, null, 8, _hoisted_21),
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.copies.Navigation.comision), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_router_link, {
                  to: "/resources",
                  class: _normalizeClass(["p-d-flex", `icon-box${_ctx.selectedTab === _ctx.NewPlatform.RESOURCES ? '-active' : ''}`]),
                  id: "sb-resources-wrapper"
                }, {
                  default: _withCtx(() => [
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", {
                        class: "lottie-icon",
                        id: `resources${_ctx.suffix}`
                      }, null, 8, _hoisted_25),
                      _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.copies.Navigation.resources), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_router_link, {
                  to: "/dashboard",
                  class: _normalizeClass(["p-d-flex", `icon-box${_ctx.selectedTab === _ctx.NewPlatform.CONTRATAR ? '-active' : ''}`]),
                  id: "sb-shop-wrapper"
                }, {
                  default: _withCtx(() => [
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", {
                        class: "lottie-icon",
                        id: `shop${_ctx.suffix}`
                      }, null, 8, _hoisted_29),
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.copies.Navigation.hiring), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["class"])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_router_link, {
                  to: "/ratings",
                  class: _normalizeClass(["p-d-flex", `icon-box${_ctx.selectedTab === _ctx.NewPlatform.RATINGS ? '-active' : ''}`]),
                  id: "sb-ratings-wrapper"
                }, {
                  default: _withCtx(() => [
                    _hoisted_31,
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", {
                        class: "lottie-icon",
                        id: `ratings${_ctx.suffix}`
                      }, null, 8, _hoisted_33),
                      _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.copies.Navigation.rating), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_router_link, {
                  to: "/chat",
                  class: _normalizeClass(["p-d-flex", `icon-box${_ctx.selectedTab === _ctx.NewPlatform.CHAT ? '-active' : ''}`]),
                  id: "sb-chat-wrapper"
                }, {
                  default: _withCtx(() => [
                    _hoisted_35,
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", {
                        class: "lottie-icon",
                        id: `chat${_ctx.suffix}`
                      }, null, 8, _hoisted_37),
                      _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.copies.Navigation.chat), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_router_link, {
                  to: "/attendance",
                  class: _normalizeClass(["p-d-flex", `icon-box${_ctx.selectedTab === _ctx.NewPlatform.ATTENDANCE ? '-active' : ''}`]),
                  id: "sb-attendance-wrapper"
                }, {
                  default: _withCtx(() => [
                    _hoisted_39,
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", {
                        class: "lottie-icon",
                        id: `attendance${_ctx.suffix}`
                      }, null, 8, _hoisted_41),
                      _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.copies.Navigation.attendance), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_router_link, {
                  to: "/dashboard",
                  class: _normalizeClass(["p-d-flex", `icon-box${_ctx.selectedTab === _ctx.NewPlatform.RESOURCES ? '-active' : ''}`]),
                  id: "sb-resources-wrapper"
                }, {
                  default: _withCtx(() => [
                    _hoisted_43,
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", {
                        class: "lottie-icon",
                        id: `resources${_ctx.suffix}`
                      }, null, 8, _hoisted_45),
                      _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.copies.Navigation.resources), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["class"])
              ], 64)),
          _createVNode(_component_router_link, {
            to: '/dashboard',
            class: _normalizeClass(["p-d-flex", `icon-box${_ctx.selectedTab === 7 ? '-active' : ''}`]),
            id: "sb-jobs-wrapper"
          }, {
            default: _withCtx(() => [
              _hoisted_47,
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", {
                  class: "lottie-icon",
                  id: `jobs${_ctx.suffix}`
                }, null, 8, _hoisted_49),
                _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.role === 2 ? _ctx.copies.Navigation.jobs : _ctx.copies.Navigation.applications), 1)
              ])
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            to: '/dashboard',
            class: _normalizeClass(["p-d-flex", `icon-box${_ctx.selectedTab === 8 ? '-active' : ''}`]),
            id: "sb-benefits-wrapper"
          }, {
            default: _withCtx(() => [
              _hoisted_51,
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", {
                  class: "lottie-icon",
                  id: `benefits${_ctx.suffix}`
                }, null, 8, _hoisted_53),
                _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.copies.Navigation.benefits), 1)
              ])
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("button", _hoisted_56, [
            _createVNode(_component_icon, {
              strokeColor: 'var(--light-gray)',
              size: 20,
              viewBox: '-7 -5 24 24'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_help)
              ]),
              _: 1
            }, 8, ["strokeColor"]),
            _createElementVNode("p", _hoisted_57, _toDisplayString(_ctx.copies.Navigation.help), 1)
          ]),
          _createElementVNode("button", _hoisted_58, [
            _createVNode(_component_icon, {
              strokeColor: 'var(--white)',
              size: 19,
              viewBox: '-13 -7 35 35'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_log_out)
              ]),
              _: 1
            }, 8, ["strokeColor"]),
            _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.copies.Navigation.logOut), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["class", "onMouseenter", "onMouseleave"]))
}